module.exports = __webpack_public_path__ + "static/media/sg3cr54.cb23c748.png";